import React from 'react';
import { useAllPermissions, useAnyPermission, usePermission } from './PermissionContext';
import { PermissionMessage } from './PermissionMessage';

interface PermissionGateProps {
  permission?: string;
  anyOf?: string[];
  allOf?: string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
  showRequiredPermissions?: boolean; // default true
}

export const PermissionGate: React.FC<PermissionGateProps> = ({
  permission,
  anyOf,
  allOf,
  children,
  fallback,
  showRequiredPermissions = true,
}) => {
  const singlePermission = usePermission(permission || '');
  const anyPermission = useAnyPermission(anyOf || []);
  const allPermissions = useAllPermissions(allOf || []);

  const has = permission ? singlePermission : anyOf ? anyPermission : allOf ? allPermissions : true;

  if (has) return <>{children}</>;
  if (fallback !== undefined) return <>{fallback}</>;
  if (!showRequiredPermissions) return null;

  const requiredPermissions = permission ? [permission] : anyOf ? anyOf : allOf ? allOf : [];
  const requirementType: 'single' | 'any' | 'all' = permission ? 'single' : anyOf ? 'any' : 'all';

  return (
    <PermissionMessage
      requiredPermissions={requiredPermissions}
      requirementType={requirementType}
    />
  );
};

